export { default } from './PresentationIcon';
